enum CacheEnum {
  //记住密码账号
  USER_TOKEN = 'USER_TOKEN',
  //记住密码密码
  USER_PASSWORD = 'USER_PASSWORD',
  // 币种存入key coin.t
  APP_LOCAL_COIN = 'APP_LOCAL_COIN',
  // 修改邮箱验证码
  APP_LOCAL_VERIFY_CODE = 'APP_LOCAL_VERIFY_CODE',
  // 修改手机号验证码
  APP_LOCAL_PHONE_VERIFY_CODE = 'APP_LOCAL_PHONE_VERIFY_CODE',
  PAGE_HOME_COIN_LIST = 'PAGE_HOME_COIN_LIST',
  //现货币种缓存
  LIST_OF_CURRENCY_TYPES = 'LIST_OF_CURRENCY_TYPES',
  APP_FAVORITES = 'APP_FAVORITES',
  APP_LOCAL_EXCHANGE_DATA = 'APP_LOCAL_EXCHANGE_DATA',
  // 交易对存入key contract.t
  APP_LOCAL_STOCK = 'APP_LOCAL_STOCK',
  APP_LOCAL_CONTRACT = 'APP_LOCAL_CONTRACT',
  // 缓存头像
  APP_AVATAR = 'APP_AVATAR',
  //C2C聊天未读
  APP_C2C_UNREAD = 'APP_C2C_UNREAD',
  PAGE_HOME_CONTRACT_LIST = 'PAGE_HOME_CONTRACT_LIST',
  //币币列表
  LIST_OF_STOCK_TYPES = 'LIST_OF_STOCK_TYPES',
  APP_AccountTypeWALLET = "APP_AccountTypeWALLET", // 账户余额 （0 sar 1usd）
  // 缓存群主id
  APP_LOCAL_GROUP_ID = 'APP_LOCAL_GROUP_ID',
  // 匿名客服未读
  APP_ANONYMOUS_UNREAD = 'APP_ANONYMOUS_UNREAD',
  // 已读的消息id
  APP_IM_READ_MESSAGE_ID = 'APP_IM_READ_MESSAGE_ID',
  // im传参信息
  APP_IM_DATA = 'APP_IM_DATA',
  // kline存入key kline.t
  KLINE_DATA_USER = 'KLINE_DATA_USER',
  // 语言存入key language.t
  I18LANGUAGE = 'LANGUAGE',
  APP_ARRANGEMENT_LANGUAGE = 'APP_ARRANGEMENT_LANGUAGE',
  APP_ARRANGEMENT_I18N = 'APP_ARRANGEMENT_I18N',
  // socket存入key socket.t
  MARKET_LIST_DATA = 'MARKET_LIST_DATA',
  SOCKET_ID_DEPTH_DATA = 'SOCKET_ID_DEPTH_DATA',
  APP_LOGIN_TYPE = 'APP_LOGIN_TYPE',

  SOCKET_ID_TRADE_DATA = 'SOCKET_ID_TRADE_DATA',
  APP_LOCAL_COIN_LIST = 'APP_LOCAL_COIN_LIST',
  APP_LOCAL_CONTRACT_LIST = 'APP_LOCAL_CONTRACT_LIST',
  APP_CONTRACT_STATISTICS = 'APP_CONTRACT_STATISTICS',
  APP_UPDATE_POSITION_DATA = 'APP_UPDATE_POSITION_DATA',
  APP_TICKLES_DATA = 'APP_TICKLES_DATA',
  //消息未数字
  APP_UNREAD_MESSAGE_COUNT = 'APP_UNREAD_MESSAGE_COUNT',
  // 主题存入key system.t
  APP_THEME = 'APP_THEME',
  // 用户存入key user.t
  APP_USER = 'APP_USER',
  AUTHORIZATION = 'AUTHORIZATION',
  REFRESHTOKEN = 'REFRESHTOKEN',
  APP_USER_NAME = 'APP_USER_NAME',
  APP_SEARCH_TYPE = 'APP_SEARCH_TYPE',
  APP_WALLETSTATISTIC = 'APP_WALLETSTATISTIC', //余额，总览
  APP_WALLETFUNDAPI = 'APP_WALLETFUNDAPI', //余额，现货 资金页面
  APP_CONTRACTWALLETAPI = 'APP_CONTRACTWALLETAPI', //余额，合约钱包
  //C2C订单步骤
  APP_C2C_ORDER_STEPS = 'APP_C2C_ORDER_STEPS', //余额，合约钱包
  //是否显示金额
  APP_SHOW_AMOUNT = 'APP_SHOW_AMOUNT',
  //充值信息
  APP_RECHARGE_INFORMATION = 'APP_RECHARGE_INFORMATION',
  //AI 列表
  APP_AI_LIST = 'APP_AI_LIST',
  // 资金记录详情
  APP_FUNDS_RECORD_DETAIL = 'APP_FUNDS_RECORD_DETAIL',
  // 资金记录跳转地址
  APP_FUNDS_RECORD_DETAIL_URL = 'APP_FUNDS_RECORD_DETAIL_URL',
  ORDER_TABSELECTED = 'ORDER_TABSELECTED',
  //App基本信息
  APP_BASE_INFO = 'APP_BASE_INFO',
  //饼图总资产
  APP_PIE_TOTAL_ASSETS = 'APP_PIE_TOTAL_ASSETS',
  //饼图总盈利
  APP_PIE_PROFIT_AND_LOSS = 'APP_PIE_PROFIT_AND_LOSS',

  // 大宗交易
  APP_LOCAL_BLOCK_TRADE = 'BLOCK_TRADE',
  PAGE_HOME_BLOCK_TRADE_LIST = 'PAGE_HOME_BLOCK_TRADE_LIST',

  //当前汇率的缓存
  APP_CURRENT_EXCHANGE_RATE_SETTING = 'APP_CURRENT_EXCHANGE_RATE_SETTING',
  APP_CURRENT_EXCHANGE_RATE_FUNDS = 'APP_CURRENT_EXCHANGE_RATE_FUNDS',
  // 当前币种的行情
  APP_CHOICE_CONTRACT_SOCKET = 'APP_CHOICE_CONTRACT_SOCKET',
  //红涨绿跌设置
  APP_UPDOWNCOLOR_CONFIG = 'APP_UPDOWNCOLOR_CONFIG',
  //是否通过引导
  APP_IS_GUIDE = 'APP_IS_GUIDE',
  //大宗详情
  APP_BLOCK_TRADE_DETAIL = 'APP_BLOCK_TRADE_DETAIL',
  //申购详情
  APP_SUBSCRIBE_DETAIL = 'APP_SUBSCRIBE_DETAIL',
  //历史订单详情
  APP_HISTORY_ORDER_DETAIL = 'APP_HISTORY_ORDER_DETAIL',
  //客服聊天未读
  APP_CUSTOMER_SERVICE_UNREAD = 'APP_CUSTOMER_SERVICE_UNREAD',
  //订单历史记录缓存
  APP_ORDER_RECORD = 'APP_ORDER_RECORD',
  //资金记录ids
  APP_FUNDS_RECORD_IDS = 'APP_FUNDS_RECORD_IDS',
  //充值记录ids
  APP_RECHARGE_RECORD_IDS = 'APP_RECHARGE_RECORD_IDS',
  //提现记录ids
  APP_WITHDRAWAL_RECORD_IDS = 'APP_WITHDRAWAL_RECORD_IDS',
  //注册页面缓存
  APP_REGISTER_CACHE = 'APP_REGISTER_CACHE',
  //找回密码数据缓存
  APP_FIND_PASSWORD_CACHE = 'APP_FIND_PASSWORD_CACHE',
  //IM消息缓存
  APP_IM_MESSAGE_CACHE = 'APP_IM_MESSAGE_CACHE',
  //版本缓存
  APP_VERSION_CACHE = 'APP_VERSION_CACHE',
  //IM历史订单缓存
  APP_IM_HISTORY_ORDER_CACHE = 'APP_IM_HISTORY_ORDER_CACHE',
  //IM历史订单ids
  APP_IM_HISTORY_ORDER_IDS = 'APP_IM_HISTORY_ORDER_IDS',
  //充值金额给客服
  APP_RECHARGE_AMOUNT = 'APP_RECHARGE_AMOUNT',
  //实名信息
  APP_REAL_NAME_INFO = 'APP_REAL_NAME_INFO',
  //缓存汇率
  APP_EXCHANGE_RATE = 'APP_EXCHANGE_RATE',
  APP_FUNDSAPI = "APP_FUNDSAPI",
}

export default CacheEnum;
